<template>
    <!-- ======= 1.09 footer Area ====== -->
    <footer class="secPdngT hero-background ">
        <div class="container">
            <div class="row">
                <div class="col-sm-3">
                    <div class="footerInfo">
                        <a href="/" class="footerLogo">
                            <img src="../../assets/images/footerLogo.png" alt="">
                        </a>
                        <div class="footerTxt">
                            <p>{{ company.description }}</p>
                        </div>
                        <ul class="footerLinkIcon">
                            <li v-for="(social, index) in socials" :key="index">
                                <a :href="social.url"><i :class="['icofont icofont-social-'+ social.icon]"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-2">
                    <widget title="Empresa" :links="company_links"></widget>
                </div>
                <div class="col-sm-2">
                    <widget title="Links úteis" :links="important_links"></widget>
                </div>
                <div class="col-sm-2">
                    <widget title="Desenvolvedores" :links="developer_links"></widget>
                </div>
                <div class="col-sm-3">
                    <div class="contactInfo">
                        <div class="h4">Entre em contacto</div>
                        <span class="call"><a :href="'tel:'+ company.tel"><i class="icofont icofont-ui-call"></i>{{ company.tel }}</a></span>
                        <span class="email"><a :href="'mailto:'+company.email"><i class="icofont icofont-ui-v-card"></i>{{ company.email }}</a></span>
                        <span>{{ company.address.avenue }}</span>
                        <span>{{ company.address.city }}</span>
                        <span>{{ company.address.country }}</span>
                        <!--<a href="#" class="contactBtn Btn">Envie-nos uma mensagem</a>-->
                        <router-link :to="{name: 'contact'}" class="contactBtn Btn">Envie-nos uma mensagem</router-link>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="copyrightTxt">
                        <p><a :href="company.ekutiva_website" target="_blank">&copy; eKutivaSolutions,</a> {{
                            current_year }}</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- ======= /1.09 footer Area ====== -->
</template>

<script>
  import Socials from '@/database/social.json'
  import Company from '@/database/company.json'
  import CompanyLinks from '@/database/company_links.json'
  import ImportantLinks from '@/database/important_links.json'
  import DeveloperLinks from '@/database/developers_links.json'
  import Widget from '../widget'

  export default {
    name: 'site-footer',
    components: {
      Widget
    },
    data() {
      return {
        socials: Socials,
        company: Company,
        company_links: CompanyLinks,
        important_links: ImportantLinks,
        developer_links: DeveloperLinks,
        current_year: (new Date()).getFullYear()
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/site/SiteFooter.vue